import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Clock, Smile } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function KidAuth() {
  const [form, setForm] = useState({ code: "", name: "", pin: "" });
  const [busy, setBusy] = useState(false);
  const { saveSession } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/parent/child-login", form);
      saveSession(data);
      toast.success(`Hi ${data.user.name}!`);
      navigate("/kid");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#7DD3FC]/30" data-testid="kid-auth-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8" data-testid="kid-auth-brand">
          <div className="w-9 h-9 rounded-xl border-2 border-zinc-900 bg-white flex items-center justify-center shadow-[3px_3px_0px_0px_#18181B]">
            <Clock className="w-5 h-5" />
          </div>
          <span className="font-display font-black text-2xl">MyTimetable.co.uk</span>
        </Link>

        <div className="nb-card p-8 bg-white">
          <div className="text-center mb-6">
            <div className="w-14 h-14 mx-auto rounded-xl border-2 border-zinc-900 bg-[#7DD3FC] flex items-center justify-center shadow-[3px_3px_0px_0px_#18181B]">
              <Smile className="w-7 h-7" />
            </div>
            <h1 className="font-display font-black text-2xl mt-4" data-testid="kid-auth-heading">Family login</h1>
            <p className="text-sm text-zinc-500 mt-1">Your parent gave you an access code and a PIN. Pop them in here to see your timetable.</p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="nb-label" htmlFor="kid-code">Access code</label>
              <input id="kid-code" className="nb-input mt-2 uppercase tracking-widest text-center font-black" data-testid="kid-code-input"
                placeholder="e.g. KX7P2Q" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })}
                required minLength={4} maxLength={12} />
            </div>
            <div>
              <label className="nb-label" htmlFor="kid-name">Your name</label>
              <input id="kid-name" className="nb-input mt-2" data-testid="kid-name-input" placeholder="e.g. Sophie"
                value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div>
              <label className="nb-label" htmlFor="kid-pin">PIN</label>
              <input id="kid-pin" type="password" inputMode="numeric" className="nb-input mt-2 text-center tracking-widest" data-testid="kid-pin-input"
                placeholder="4–6 digits" value={form.pin} onChange={(e) => setForm({ ...form, pin: e.target.value })} required minLength={4} maxLength={12} />
            </div>
            <button type="submit" disabled={busy} data-testid="kid-auth-submit" className="nb-btn w-full bg-[#7DD3FC] py-3">
              {busy ? "Checking…" : "See my timetable"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
